// Touch stays with the browser. A mouse can grab a catalogue to scroll it;
// holding a material briefly opts into its existing drag-to-nail interaction.
const SCROLL_AREAS='.st-content,.st-material-grid,.st-shape-list,.st-groups,.pt-shape-series';
const INPUTS='input,select,textarea,label,a,[contenteditable=true],[role=slider],[data-no-drag-scroll]';
const HOLD_MS=380;

export function installStudioDragScroll(root) {
  let gesture=null,ignoreClickUntil=0;
  const clean=()=>{
    if(!gesture)return;
    clearTimeout(gesture.timer);
    gesture.material?.classList.remove('effect-drag-ready');
    root.classList.remove('is-mouse-scrolling');
    const id=gesture.id;gesture=null;
    if(root.hasPointerCapture?.(id))root.releasePointerCapture(id);
  };
  const candidates=target=>{
    const items=[];
    for(let el=target;el&&root.contains(el);el=el.parentElement){
      if(!el.matches(SCROLL_AREAS))continue;
      const style=getComputedStyle(el);
      const x=/(auto|scroll)/.test(style.overflowX)&&el.scrollWidth>el.clientWidth+2;
      const y=/(auto|scroll)/.test(style.overflowY)&&el.scrollHeight>el.clientHeight+2;
      if(x||y)items.push({el,x,y,left:el.scrollLeft,top:el.scrollTop});
    }
    return items;
  };
  const down=e=>{
    if(e.isPrimary&&e.button===0)ignoreClickUntil=0;
    if(e.pointerType!=='mouse'||e.button!==0||!e.isPrimary)return;
    if(e.target.closest(INPUTS)||!e.target.closest('.st-content'))return;
    const areas=candidates(e.target);
    if(!areas.length)return;
    // Preserve a real scrollbar's native thumb, track and arrow interactions.
    for(const {el} of areas){
      const box=el.getBoundingClientRect();
      if((el.offsetWidth-el.clientWidth>4&&e.clientX>=box.left+el.clientLeft+el.clientWidth)||
         (el.offsetHeight-el.clientHeight>4&&e.clientY>=box.top+el.clientTop+el.clientHeight))return;
    }
    clean();
    const material=e.target.closest('[data-effect-kind]');
    gesture={id:e.pointerId,x:e.clientX,y:e.clientY,areas,material,armed:false,active:false};
    if(material)gesture.timer=setTimeout(()=>{
      if(!gesture||gesture.id!==e.pointerId||gesture.active)return;
      gesture.armed=true;material.classList.add('effect-drag-ready');
    },HOLD_MS);
  };
  const move=e=>{
    if(!gesture||gesture.id!==e.pointerId||gesture.armed)return;
    const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
    if(!gesture.active){
      if(Math.hypot(dx,dy)<7)return;
      clearTimeout(gesture.timer);
      const axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
      const area=gesture.areas.find(item=>item[axis]);
      if(!area){clean();return;}
      gesture.area=area;gesture.axis=axis;gesture.active=true;
      root.classList.add('is-mouse-scrolling');root.setPointerCapture?.(e.pointerId);
    }
    e.preventDefault();
    const {area,axis}=gesture;
    if(axis==='x')area.el.scrollLeft=area.left-dx;
    else area.el.scrollTop=area.top-dy;
  };
  const end=e=>{
    if(!gesture||gesture.id!==e.pointerId)return;
    if(gesture.active)ignoreClickUntil=Date.now()+500;
    clean();
  };
  const click=e=>{
    if(e.detail!==0&&Date.now()<ignoreClickUntil){e.preventDefault();e.stopPropagation();}
  };
  const drag=e=>{
    if(!gesture)return;
    if(gesture.armed){clean();return;}
    e.preventDefault();
  };
  root.addEventListener('pointerdown',down,true);
  root.addEventListener('click',click,true);
  root.addEventListener('dragstart',drag,true);
  root.addEventListener('lostpointercapture',end);
  window.addEventListener('pointermove',move,{capture:true,passive:false});
  window.addEventListener('pointerup',end,true);
  window.addEventListener('pointercancel',end,true);
  window.addEventListener('blur',clean);
  return()=>{
    clean();root.removeEventListener('pointerdown',down,true);root.removeEventListener('click',click,true);
    root.removeEventListener('dragstart',drag,true);root.removeEventListener('lostpointercapture',end);
    window.removeEventListener('pointermove',move,true);window.removeEventListener('pointerup',end,true);
    window.removeEventListener('pointercancel',end,true);window.removeEventListener('blur',clean);
  };
}
